import { Col } from 'components/Col';
import { HelpButton } from 'components/HelpButton';
import RefreshIcon from 'components/Icons/RefreshIcon';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { Fragment, useContext, useMemo } from 'react';
import languageValues from 'utils/LanguageUtils';
import MenuEtapas from './menuEtapas/menuEtapas';
import styles from './titleEtapa.scss';
const { rootClassName } = styles;

const language = languageValues.pages.projetos.etapas;
export default function TitleEtapa({ etapa }: { etapa: EtapaProjeto }) {
  const {
    state: { projeto, etapasLoading },
  } = useContext(ProjetosContext);

  const title = useMemo(() => {
    const item = language[etapa].name;
    if (typeof item === 'function') {
      return item(projeto.flgInfantil);
    }
    return item;
  }, [etapa, projeto.flgInfantil]);

  const help = useMemo(() => {
    const item = language[etapa].tooltipText;
    if (typeof item === 'function') {
      return item(projeto.flgInfantil);
    }
    return item;
  }, [etapa, projeto.flgInfantil]);

  return (
    <Row>
      <Col className={rootClassName}>
        <MenuEtapas>
          <div className={`${rootClassName}-content`}>
            {title}
            <HelpButton text={help} />
            {etapa in etapasLoading && etapasLoading[etapa] ? (
              <div className={`${rootClassName}-loader`}>
                <RefreshIcon />
              </div>
            ) : (
              <Fragment />
            )}
          </div>
        </MenuEtapas>
      </Col>
    </Row>
  );
}
